import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { PatientVitalsScreen } from 'screens/patient';

export default withPermissions(PatientVitalsScreen, [
  GroupSecurity.ObservationRead,
]);
